import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProviderWrapper } from "./ThemeContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import store from "./store";
import { AppConsts } from "core/AppConsts";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

document.body.classList.add("dev-mode");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <ThemeProviderWrapper>
    <Provider store={store}>
      <GoogleReCaptchaProvider reCaptchaKey={AppConsts.reCaptchaKey}>
        <App />
      </GoogleReCaptchaProvider>
    </Provider>
  </ThemeProviderWrapper>
);

serviceWorkerRegistration.unregister();
reportWebVitals();
